import { Stack, Typography, useTheme } from '@mui/material';

import { Strings } from '@app/constants';
import { AuthLayout } from '@app/layouts';
import { ForgotPasswordForm } from './forgot-password-form';

// ------------------------------------------------

const ForgotPasswordPage = () => {
  const theme = useTheme();
  return (
    <AuthLayout title={Strings.header.forgotPassword}>
      <Stack spacing={2}>
        <Typography variant="h3" mb={'2px'}>
          {Strings.auth.forgotPasswordHeading}
          <Typography color={theme.palette.grey[600]}>{Strings.auth.enterYourEmail}</Typography>
        </Typography>
        <ForgotPasswordForm />
      </Stack>
    </AuthLayout>
  );
};

export { ForgotPasswordPage };
